import { BaseInjectProxy } from './BaseInjectProxy';

/**
 * フレームワークで使用するサービスを集約する
 */
export class BaseInjectProxyImpl implements BaseInjectProxy {

    /**
     * @constructor
     * @param {ng.IRootScopeService} $rootScope ルートスコープ
     * @param {ng.IQService} $q 非同期処理
     * @param {ng.IQService} $state UI Routerのステータス
     */
    constructor(protected $rootScope: ng.IRootScopeService,
                protected $q: ng.IQService,
                protected $state: angular.ui.IStateService) {

    }

    /**
     * UI Routerのstateを取得
     * @return {angular.ui.IStateService} UI Routerのstate
     */
    public getState(): angular.ui.IStateService {
        return  this.$state;
    }

    /**
     * rootScopeを取得
     * @return {ng.IRootScopeService} rootScope
     */
    public getRootScope(): ng.IRootScopeService {
        return this.$rootScope;
    }

    /**
     * $qを取得
     * @return {ng.IQService} $q
     */
    public getQ(): ng.IQService {
        return this.$q;
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/framework/BaseInjectProxyImpl.ts
 **/